import React, { Component } from 'react';
import Summary from '../../components/Summary/Summary';
import { Link } from 'react-router-dom';

import styles from './notfound.css';

import NotFoundHelmet from './Helmet';

function NotFound() {
  const title = `Page Not Found`
  const data = `<p><strong>Not Found</strong> — This is not the page you are searching for. Please press the circle button to get back home.🍇🍆</p>`;

  return (
    <section className={styles.content}>
      <NotFoundHelmet />
        <Summary data={data} />
        <Link className={styles.closeLink} to="/">
          <div className={styles.closeButton} />
        </Link>
    </section>
  );
}


export default NotFound;



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js